import { FC } from 'react';
export type ChipIntent = 'default' | 'error' | 'warning' | 'accent' | 'ai';
export const CHIP_INTENTS = [
  'default',
  'error',
  'warning',
  'accent',
  'ai',
] as const;
interface ChipProps {
  text: string;
  isHeader?: boolean;
  className?: string;
  intent?: ChipIntent;
  setChipToNoMargin?: boolean;
}
const chipConfig = {
  baseStyles:
    'px-xs my-0 py-0.5 rounded-2xs text-xs flex items-center justify-center self-center',
  whenInHeader: 'text-sm',
  intents: {
    default: 'bg-primary/10 text-primary',
    error: 'bg-error/10 text-error',
    warning: 'bg-warning/10 text-warning',
    accent: 'bg-accent/10 text-accent',
    ai: 'bg-ai/15 text-ai',
  } as const,
};
const Chip: FC<ChipProps> = ({
  text,
  isHeader = false,
  className = '',
  intent = 'default',
  setChipToNoMargin = false,
}) => {
  return (
    <div
      className={`
        ${chipConfig.baseStyles}
        ${chipConfig.intents[intent]}
        ${isHeader ? chipConfig.whenInHeader : ''}
        ${setChipToNoMargin ? 'mx-0' : 'mx-xs'}
        ${className}
      `.trim()}
    >
      {text}
    </div>
  );
};
export default Chip;
